// extracted by mini-css-extract-plugin
export default {"wrapper":"Impersonation_wrapper__Y0Mn+","alertIcon":"Impersonation_alertIcon__-Oppz","text":"Impersonation_text__MiCSN","button":"Impersonation_button__oAKe7"};